import OrganizerEditForm from "./organizer-edit-form";

export default OrganizerEditForm;